<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Имя">
          <b-input
            name="reviewer"
            placeholder="Имя"
            icon="user"
            v-model="model.reviewer">
          </b-input>
        </b-field>
        <b-field
          label="Электронной почта"
          :type="{'is-danger': errors.has('email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('email', 'required')
          }]">
            <b-input
              name="email"
              placeholder="Email"
              type="email"
              icon="at"
              v-validate="'required'"
              v-model="model.email">
            </b-input>
        </b-field>
        <b-field label="Сообщение">
          <b-input
            type="textarea"
            name="message"
            :disabled="id!=undefined"
            v-model="model.message">
          </b-input>
        </b-field>
        <b-field label="Состояние">
          <b-select placeholder="Состояние отзыва" expanded v-model="model.is_active">
            <option
              v-for="option in states"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'ReviewForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    const states = [
      {
        id: true,
        name: "Разрешена публикация"
      },
      {
        id: false,
        name: "Не разрешена публикация"
      }
    ]
    return {
      states: states,
      model: {
        id: undefined,
        email: '',
        name: '',
        message: null
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getReview', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = {}
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateReview', $this.model)
      }
      else{
        $this.$store.dispatch('createReview', $this.model)
      }
    }  
  }
}
</script>

<style scoped>
</style>
<style>
</style>